import { useCallback, useState } from 'react';
import { View } from 'react-native';
import { AudioPlayer } from '../AudioPlayer';
import { HearingChoices } from '../HearingChoices';
import { TextBody } from '../SpeakingExercise/textBody';

import { styles } from './styles';

export function Body({
  id,
  questions,
  questionIndex,
  settings,
  choices,
  onPressChoice,
  playbackRate = 1.0,
}) {
  const { questionAudio } = questions?.[questionIndex] ?? {};
  const [activeAudioSrc, setActiveAudioSrc] = useState('');

  const changeActiveAudioSrc = useCallback((src) => {
    setActiveAudioSrc(src);
  }, []);

  return (
    <View style={[styles.flexContainer, styles.bodyContainer]}>
      {settings === 'open' ? (
        <TextBody
          id={id}
          questions={questions}
          questionIndex={questionIndex}
          playbackRate={playbackRate}
        />
      ) : (
        <>
          <View style={styles.playerContainer}>
            <AudioPlayer
              isStopAllOnPlay
              changeActiveAudioSrc={changeActiveAudioSrc}
              playingAudioSrc={activeAudioSrc}
              source={questionAudio}
              autoPlay
              playbackRate={playbackRate}
            />
          </View>
          <View style={styles.miniPlayerContainer}>
            <HearingChoices
              changeActiveAudioSrc={changeActiveAudioSrc}
              activeAudioSrc={activeAudioSrc}
              choices={choices}
              onPressChoice={onPressChoice}
              playbackRate={playbackRate}
            />
          </View>
        </>
      )}
    </View>
  );
}
